const TransactionPage = () => {
  return <div>Transaction Page</div>;
};

export default TransactionPage;
